export default __webpack_public_path__ + "static/media/discord.895857a2.svg";